import React from "react";
import ReactModal from "react-modal";
import "../add-applications-modal.scss";
import { Formik } from "formik";
import { Form, Col, Row, Button } from "react-bootstrap";
import Loader from "../../../loader/loader";
import SelectDropDown from "../../../shared/drop-down/drop-down";
import HelpIcon from "@material-ui/icons/Help";
import ReactTooltip from "react-tooltip";
import Cleave from "cleave.js/react";
import Select from "react-select";
import {
  CreateApplication,
  GetPricingEquipmentTemplate,
  getTemplateList,
  OrganisationData,
  GetEquipmentTemplate,
  GetMccList,
  GetData,
  GetPricingEquipmentTemplateById,
  getActiveBanks,
  ListOfPdfs,
  GetMCCRecordById,
  getEmsOfficesByUser,
} from "../../../../api";
import * as yup from "yup";
import config from "../../../../config";
import { FaRegEdit } from "react-icons/fa";
import EditPricingCreateApp from "./edit-pricing";
import EditEquipmentCreateApp from "./edit-equipment";
import { FaPlus } from "react-icons/fa";

const phoneRegex =
  /^\(?(?:[0-9]{3})\)?[-.\s+]?(?:[0-9]{3})[-.\s+]?(?:[0-9]{4})$/;
const MAIN_URL = config.paymentcloud.MAIN_URL;

const schema = yup.object({
  field_dba: yup.string().trim().required("* DBA name is required"),
  field_businessemail: yup
    .string()
    .email("* Invalid email Address")
    .when("showRequiredField", (fieldRequired, schema) => {
      return fieldRequired === "no"
        ? schema
        : schema.required("* Email is required");
    }),
  field_businessphone: yup
    .string()
    .matches(phoneRegex, "* Enter mobile phone number correctly.")
    .when("showRequiredField", (fieldRequired, schema) => {
      return fieldRequired === "no"
        ? schema
        : schema.required("* Mobile phone number is required");
    }),
});

class ApplicationFormTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      is_submitted: false,
      formData: {
        field_dba: "",
        field_businessemail: "",
        field_businessphone: "",
        field_businesstype: "",
        field_mcc: "",
        override_bank: [],
        template_id: "",
        price: "",
        equipment: "",
        submit_type: "",
        ems_office_id: "",
      },
      initialErrors: [],
      show_spinner: true,
      errorMessage: "",
      templatesList: {},
      pricingTemplates: {},
      equipmentTemplates: {},
      templatesOptions: [],
      applicationUrl: "",
      orgtemplatesList: [],
      systemtemplatesList: [],
      userLevelTemplateList: [],
      mccList: [],
      bankList: [],
      selectedPdf: [],
      activeTypeOfBank: null,
      selectedTypeOfBanks: [],
      listOfPdfs: [],
      formError: false,
      ems_offices: [],
      bank_file_mapping: {},
      editPricingModal: false,
      editEquipmentModal: false,
    };
  }
  componentDidMount() {
    this.getTemplateList();
    this.getPricingTemplates();
    this.getEquipmentTemplates();
    if (this.props.editPrevetId && this.props.editPrevet) {
      GetData(this.props.editPrevetId).then((res) => {
        if (res.success) {
          if (
            Array.isArray(res.data.prices) &&
            res.data.prices.length > 0
          ) {
            this.setState({
              windowMessage:
                "This application is no longer in prevet stage ",
            });
            setTimeout(() => {
              this.props.handleCloseCreatedAppModel();
            }, 5000);
          } else {
            this.setState({
              formData: {
                ...this.state.formData,
                field_dba: res.data.field_dba,
                field_businessemail: res.data.field_email,
                field_businessphone:
                  res.data.field_personalphone,
              },
            });
          }
        } else {
          this.setState({
            windowMessage:
              "This application is no longer in prevet stage ",
          });
          setTimeout(() => {
            this.props.handleCloseCreatedAppModel();
            this.props.history.push("/applications");
          }, 5000);
        }
      });
    }

    getEmsOfficesByUser(this.props.user.id)
      .then((res) => {
        if (res.status && res.data !== null) {
          this.setState({ ems_offices: res.data });
        }
      })
      .catch();
  }

  handleAddApplication = (evt) => {
    if (this.state.errorMessage == "") {
      const fromData = this.state.formData;
      let fd = new FormData();
      fd.append("field_dba", fromData.field_dba);
      fd.append("field_businessemail", fromData.field_businessemail);
      fd.append("field_businessphone", fromData.field_businessphone);
      fd.append("field_businesstype", fromData.field_businesstype);
      fd.append("field_mcc", fromData.field_mcc);
      fd.append("price", fromData.price);
      fd.append("equipment", fromData.equipment);
      fd.append("submit_type", fromData.submit_type);
      fd.append("ems_office_id", fromData.ems_office_id);
      fd.append("bank", JSON.stringify(this.state.selectedTypeOfBanks));
      fd.append("addendum", JSON.stringify(this.state.selectedPdf));
      if (this.props.editPrevet && this.props.editPrevetId) {
        fd.append("editslug", this.props.editPrevetId);
      }

      const { user } = this.props;
      if (user?.is_ems_user) {
        if (fromData.ems_office_id == "") {
          this.setState({
            errorMessage: "*EMS Office ID is required!",
          });
          return;
        }
      }
      if (this.props.user?.channel == "sales_channel") {
      } else {
        if (this.state.formData.price == "") {
          this.setState({
            errorMessage:
              "*Pricing is required, Please select pricing template or fill it manually!",
          });
          return;
        }

        if (this.state.formData.equipment == "") {
          this.setState({
            errorMessage:
              "*Equipment is required, Please select Equipment template or fill it manually!",
          });
          return;
        }
      }

      this.setState({ show_spinner: true });
      CreateApplication(fd)
        .then((response) => {
          this.setState({ show_spinner: false });
          if (response.status === true) {
            if (fromData.submit_type == "SaveAndRedirect") {
              window.location =
                this.state.applicationUrl +
                "/" +
                response.data.editslug;
            } else {
              this.props.handleCloseCreatedAppModel();
              this.props.getPreappData();
            }
          } else {
            this.setState({ smtpErrorMessage: response.message });
          }
        })
        .catch((error) => {
          this.setState({ show_spinner: false });
        });
    }
  };

  updateSubmitType(event) {
    let formData = this.state.formData;
    formData["submit_type"] = event;
  }
  updateChange(event) {
    const targetName = event.target.name;
    if (targetName === "") {
      return false;
    }
    let formData = this.state.formData;
    formData[targetName] = event.target.value.trim();

    this.setState({ formData: formData, errorMessage: "" });
  }

  getTemplateList() {
    let organizationId = this.props.user
      ? this.props.user.organization_id
      : null;
    const searchTerm = {
      organization_id: organizationId,
      with_system_level: true,
    };
    // system with organization Template
    GetPricingEquipmentTemplate(searchTerm)
      .then((response) => {
        if (response.success === true) {
          this.setState({ templatesList: response.data }, () =>
            this.getOrgTemplate(),
          );
        } else {
          this.handleTempOptions();
        }
      })
      .catch((error) => console.log(error));

    if (this.props.user.agent_url) {
      OrganisationData()
        .then((response) => {
          let URLCreate = "";
          let agent_url = this.props?.user?.agent_url;
          let org_slug = this.props?.user?.organization?.whitelabel_slug;
          let channel = this.props?.user?.channel;
          let org_id = this.props?.user?.organization_id;
          if (channel == 'sales_channel') {
            if (org_id == config.paymentcloud.EMS_ORG_ID
              || org_id == config.paymentcloud.PAYCHEX_ORG_ID) {
              URLCreate = "https://application.stratusapp.io/" + agent_url;
            } else {
              URLCreate = "https://apply.paymentcloudinc.com/" + agent_url;
            }
          } else {
            URLCreate = "https://apply.paymentcloudinc.com/" + org_slug + "/" + agent_url;
          }
          this.setState({ applicationUrl: URLCreate });
        })
        .catch((error) => console.log(error));
    }
  }
  getOrgTemplate() {
    let organizationId = this.props.user
      ? this.props.user.organization_id
      : null;
    const orgTemplate = {
      organization_id: organizationId,
    };
    GetPricingEquipmentTemplate(orgTemplate)
      .then((response) => {
        if (response.success === true) {
          this.setState({ orgtemplatesList: response.data }, () =>
            this.systemOrgTemplate(),
          );
        } else {
          this.systemOrgTemplate();
        }
      })
      .catch((error) => console.log(error));
  }
  UserLevelTemplate() {
    const searchTerm = {
      user_id: this.props.user ? this.props.user.id : null,
    };
    GetPricingEquipmentTemplate(searchTerm)
      .then((response) => {
        if (response.success === true) {
          this.setState(
            { userLevelTemplateList: response.data },
            () => this.handleTempOptions(),
          );
        } else {
          this.handleTempOptions();
        }
      })
      .catch((error) => console.log(error));
  }
  systemOrgTemplate() {
    const systemTemplate = {
      system_level: true,
    };
    GetPricingEquipmentTemplate(systemTemplate)
      .then((response) => {
        if (response.success === true) {
          this.setState({ systemtemplatesList: response.data }, () =>
            this.UserLevelTemplate(),
          );
        } else {
          this.UserLevelTemplate();
        }
      })
      .catch((error) => console.log(error));
  }
  handleTempOptions() {
    const orgTemplateOption = this.state.orgtemplatesList.map((t) => {
      return {
        value: t.id,
        label: t.template_name,
      };
    });
    const systemTemplateOption = this.state.systemtemplatesList.map((t) => {
      return {
        value: t.id,
        label: t.template_name,
      };
    });
    const userTemplateOption = this.state.userLevelTemplateList.map((t) => {
      return {
        value: t.id,
        label: t.template_name,
      };
    });
    const DropDownOptions = [
      {
        label: "System Templates",
        options: systemTemplateOption,
      },
      {
        label: "Organization Templates",
        options: orgTemplateOption,
      },
      {
        label: "User Templates",
        options: userTemplateOption,
      },
    ];
    this.setState({ templatesOptions: DropDownOptions }, () => {
      this.getMccData();
      this.getBankList();
    });
  }

  getPricingTemplates() {
    let organizationId = this.props.user
      ? this.props.user.organization_id
      : null;
    getTemplateList(organizationId).then((response) => {
      if (response.success) {
        this.setState({ pricingTemplates: response.data }, () =>
          getTemplateList("").then((response) => {
            if (response.success) {
              this.setState({
                pricingTemplates:
                  this.state.pricingTemplates.concat(
                    response.data,
                  ),
              });
            }
          }),
        );
      }
    });
  }
  getEquipmentTemplates() {
    const searchTerm = {};
    GetEquipmentTemplate(searchTerm)
      .then((response) => {
        if (response.success === true) {
          this.setState({ equipmentTemplates: response.data });
        }
      })
      .catch((error) => console.log(error));
  }

  handleTemplateOptionChange(selectedOption) {
    const formData = this.state.formData;
    this.setState({ show_spinner: true });
    GetPricingEquipmentTemplateById(selectedOption.value)
      .then((response) => {
        if (response.success) {
          let data = response.data;
          if (
            data.equipment_template == null ||
            data.equipment_template == ""
          ) {
            this.setState({
              errorMessage:
                "Sorry! this template don't have equipment template.",
            });
          } else if (
            data.pricing_template == null ||
            data.pricing_template == ""
          ) {
            this.setState({
              errorMessage:
                "Sorry! this template don't have pricing template.",
            });
          } else {
            formData["equipment"] =
              data.equipment_template.template;
            formData["price"] =
              data.pricing_template.pricing_template;
            this.setState({ errorMessage: "" });
          }
        } else {
          this.setState({
            errorMessage:
              "Sorry! something went wrong please try again.",
          });
        }
        this.setState({ show_spinner: false });
      })
      .catch((error) => {
        this.setState({
          show_spinner: false,
          errorMessage:
            "Sorry! something went wrong please try again.",
        });
      });
    formData["template_id"] = selectedOption.value;
    this.setState({ formData: formData, formError: false });
  }

  handleMccChange(selectedOption) {
    const { user } = this.props;
    if (user?.channel == "sales_channel" && user?.organization_id == 1) {
      const formData = this.state.formData;
      formData["field_mcc"] = selectedOption.value;
      this.getMccRecord(selectedOption?.mcc_id);
      this.setState({ formData: formData });
    } else {
      const formData = this.state.formData;
      formData["field_mcc"] = selectedOption.value;
      this.getMccRecord(selectedOption?.mcc_id);
      this.setState({ formData: formData });
    }
  }

  handleBankChange(selectedOption) {
    this.setState({ selectedTypeOfBanks: selectedOption });
    const formData = this.state.formData;
    formData["override_bank"] = selectedOption;
    const selected_banks = formData["override_bank"];
    let allowed_addendums = [];
    selected_banks.forEach((bank) => {
      let addendums = this.state.bank_file_mapping[bank.value]?.addendums;
      if (addendums) {
        allowed_addendums.push(...addendums);
      }
    });
    let updated_selected_pdfs = [];
    this.state.selectedPdf.forEach((pdf) => {
      if (allowed_addendums.includes(pdf)) {
        updated_selected_pdfs.push(pdf);
      }
    });

    this.setState(
      {
        formData: formData,
        selectedPdf: updated_selected_pdfs,
        activeTypeOfBank: null,
      },
      () => {
        let active_bank = this.state.formData?.override_bank?.[0];
        if (active_bank) {
          let list_of_pdfs =
            this.state.bank_file_mapping[active_bank?.value];
          this.setState({
            activeTypeOfBank:
              this.state.formData?.override_bank?.[0],
            listOfPdfs: list_of_pdfs?.addendums,
          });
        }
      },
    );
  }

  getMccData() {
    const payload = {};
    GetMccList(payload)
      .then((response) => {
        if (response.success === true) {
          const mccOption = response.data.map((t) => {
            return {
              value: t.id,
              label: t.description,
              mcc_id: t.mcc,
            };
          });
          this.setState({ mccList: mccOption }, () =>
            this.setState({ show_spinner: false }),
          );
        } else {
          this.setState({ show_spinner: false });
        }
      })
      .catch((error) => console.log(error));
  }

  getMccRecord = async (id) => {
    await GetMCCRecordById(id)
      .then((res) => {
        if (res?.success && res?.data) {
          let temp_selected_banks = [];
          let temp_selected_addendums = [];
          if (
            res?.data?.bank &&
            Object.keys(res?.data?.bank)?.length
          ) {
            res?.data?.bank?.map((value) => {
              temp_selected_banks.push({
                value: value?.label,
                label: value?.label,
              });
            });
          }
          if (res?.data?.addendums) {
            if (Object.keys(res?.data?.addendums)?.length) {
              res?.data?.addendums?.map((value) => {
                temp_selected_addendums.push(value?.label);
              });
            }
          }
          const formData = this.state.formData;
          if (formData.override_bank.length == 0) {
            formData["override_bank"] = temp_selected_banks;
            this.setState({
              selectedPdf: this.uniqueArray([
                ...this.state.selectedPdf,
                ...temp_selected_addendums,
              ]),
              selectedTypeOfBanks: this.uniqueArray([
                ...this.state.selectedTypeOfBanks,
                ...temp_selected_banks,
              ]),
              activeTypeOfBank: temp_selected_banks?.[0] || null,
            });
          }
          this.setState(
            {
              formData: formData,
            },
            this.setPdfList,
          );
        }
      })
      .catch((err) => console.log(err));
  };
  getBankList() {
    getActiveBanks().then((res) => {
      if (res.data) {
        const options = res.data.length
          ? res.data.map((i) => ({ value: i.name, label: i.name }))
          : [];
        this.setState({ bankList: [...options] }, () =>
          this.setState({ show_spinner: false }),
        );
      } else {
        this.setState({ show_spinner: false });
      }
    });
    ListOfPdfs().then((res) => {
      if (res?.data?.bank_file_mapping) {
        this.setState({
          bank_file_mapping: res?.data?.bank_file_mapping,
        });
      }
    });
  }

  isDisabled = (errors) => {
    if (Array.isArray(errors) || this.state.formError === true) {
      return true;
    } else if (typeof errors === "object") {
      const values = Object.values(errors);
      if (values.length === 0) {
        return false;
      } else if (values.length > 0) {
        if (values.every((el) => el == "")) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    } else {
      return false;
    }
  };

  templateReset() {
    const formData = this.state.formData;
    formData["template_id"] = "";
    formData["price"] = "";
    formData["equipment"] = "";
    this.setState({ formData: formData, formError: true });
  }

  onSelecttypeOfBank(typeOfBank) {
    this.setState({ activeTypeOfBank: typeOfBank }, this.setPdfList);
  }

  onChangePdf(e, item) {
    const isChecked = e.target.checked;
    const itemName = item;
    this.setState((prevState) => {
      if (isChecked) {
        return { selectedPdf: [...prevState.selectedPdf, itemName] };
      } else {
        return {
          selectedPdf: prevState.selectedPdf.filter(
            (name) => name !== itemName,
          ),
        };
      }
    });
  }

  setPdfList() {
    const pdf_list =
      this.state.bank_file_mapping[this.state?.activeTypeOfBank?.value];
    const addendums = pdf_list?.addendums;
    if (Array.isArray(addendums)) {
      this.setState({ listOfPdfs: addendums });
    } else {
      this.setState({ listOfPdfs: [] });
    }
  }

  setUpdatePricingData(pricing) {
    this.setState({
      formData: {
        ...this.state.formData,
        price: JSON.stringify(pricing),
      },
      editPricingModal: false,
      errorMessage: "",
    });
  }

  setUpdateEquipmentData(equipment) {
    this.setState({
      formData: {
        ...this.state.formData,
        equipment: JSON.stringify(equipment),
      },
      editEquipmentModal: false,
      errorMessage: "",
    });
  }

  uniqueArray = (arr) => {
    if (arr.length === 0) return arr;
    if (typeof arr[0] === "object") {
      const uniqueSet = new Set();
      return arr.filter((item) => {
        if (!uniqueSet.has(item.value)) {
          uniqueSet.add(item.value);
          return true;
        }
        return false;
      });
    } else {
      return Array.from(new Set(arr));
    }
  };

  render() {
    const {
      errorMessage,
      show_spinner,
      is_submitted,
      formData,
      initialErrors,
      windowMessage,
      ems_offices,
    } = this.state;

    const { user } = this.props;

    return windowMessage ? (
      <div>
        <h3>{windowMessage}</h3>
      </div>
    ) : (
      <div className="add-application-wrapper">
          {this.props?.user?.channel == 'sales_channel' ? <></> :
            <Row className="mb-5">
              <Col xs={4} md={4}></Col>
              <Col xs={4} md={4} className="p-0">
                <a
                  className="btn btn-success w-100"
                  href={this.state.applicationUrl}
                  title="Create"
                >
                  {" "}
                  Continue To Application{" "}
                </a>
              </Col>
              <Col xs={4} md={4}></Col>
            </Row>
          }
        <Row>&nbsp;</Row>
        <Formik
          enableReinitialize
          validationSchema={schema}
          onSubmit={(e) => this.handleAddApplication(e)}
          initialValues={formData}
          initialErrors={initialErrors}
          validateOnBlur={true}
          validateOnChange={true}
          validateOnMount={true}
          validate={(values) => {
            this.setState({ is_submitted: true });
          }}
        >
          {({
            handleSubmit,
            handleChange,
            values,
            touched,
            errors,
            handleBlur,
          }) => (
            <>
              <Form
                id="add-application-form"
                onSubmit={handleSubmit}
                onChange={(e) => this.updateChange(e)}
                autoComplete="off"
              >
                <Form.Row>
                  <Form.Group
                    as={Col}
                    xs={12}
                    className="px-3"
                  >
                    <Form.Control
                      placeholder="DBA Name"
                      type="text"
                      name="field_dba"
                      value={values.field_dba}
                      onChange={handleChange}
                      isInvalid={
                        touched.field_dba &&
                        !!errors.field_dba
                      }
                      isValid={
                        is_submitted &&
                        !errors.field_dba
                      }
                      className="preapp-form-input"
                    />
                    <label className="modal-lab">
                      DBA Name *
                    </label>
                  </Form.Group>
                </Form.Row>

                  <Form.Row>
                    <Form.Group
                      as={Col}
                      xs={12}
                      className="px-3"
                    >
                      <Form.Control
                        placeholder="Email"
                        type="email"
                        name="field_businessemail"
                        value={values.field_businessemail}
                        onChange={handleChange}
                        isInvalid={
                          touched.field_businessemail &&
                          !!errors.field_businessemail
                        }
                        isValid={
                          is_submitted &&
                          !errors.field_businessemail
                        }
                        className="preapp-form-input"
                      />
                      <label className="modal-lab">
                        Business Email *
                      </label>
                    </Form.Group>
                  </Form.Row>

                  <Form.Row>
                    <Form.Group
                      className="px-3 field_businessphone"
                      controlId="field_businessphone"
                    >
                      <div className="d-flex flex-row phone-prefix">
                        <Cleave
                          options={{
                            blocks: [3, 3, 4],
                            delimiter: "-",
                            numericOnly: true,
                          }}
                          placeholder="Mobile Phone"
                          name="field_businessphone"
                          value={
                            values.field_businessphone
                          }
                          onChange={handleChange}
                          type="text"
                          inputMode="numeric"
                          className={`preapp-form-input form-control ${is_submitted &&
                            !errors.field_businessphone &&
                            "is-valid"
                            } ${touched.field_businessphone &&
                            !!errors.field_businessphone &&
                            "is-invalid"
                            }`}
                        />
                      </div>
                      <label className="modal-lab">
                        Mobile Phone *{" "}
                        <HelpIcon
                          id="myHelpIcon"
                          data-tip
                          data-for="registerTip-phone"
                        />{" "}
                      </label>
                      <ReactTooltip
                        data-tip-disable={false}
                        id="registerTip-phone"
                        place="bottom"
                        effect="solid"
                        getContent={() => (
                          <div>
                            This number will be used for
                            2 factor authentication.
                            Your merchant will have
                            <br />
                            to enter a code that is sent
                            via text to access their
                            application.
                          </div>
                        )}
                      />
                    </Form.Group>
                  </Form.Row>

                  <Form.Row>
                    <Form.Group
                      as={Col}
                      xs={12}
                      className="px-3"
                    >
                      <SelectDropDown
                        options={this.state.mccList}
                        name="field_mcc"
                        placeholder="Select MCC"
                        value=""
                        handleChange={(selected) => {
                          values.field_mcc =
                            selected.value;
                          this.handleMccChange(selected);
                          errors.field_mcc = "";
                        }}
                        touched={touched.field_mcc}
                        errors={errors.field_mcc}
                        is_submitted={is_submitted}
                        isSearchable={true}
                      />
                      <label className="modal-lab">
                        MCC (Optional)
                      </label>
                    </Form.Group>
                  </Form.Row>
                  {user?.channel == 'sales_channel' ? <></> :
                    <>
                      <Form.Row>
                        <Form.Group
                          as={Col}
                          xs={12}
                          className="px-3 select_bank_dropdown "
                        >
                          <Select
                            options={this.state.bankList}
                            name="override_bank"
                            placeholder="Select Bank"
                            value={values.override_bank}
                            onChange={(selected) => {
                              let TempBank = [];
                              selected?.forEach(
                                function (item) {
                                  TempBank.push(item);
                                },
                              );
                              values.override_bank =
                                TempBank;
                              this.handleBankChange(
                                TempBank,
                              );
                              errors.override_bank = "";
                            }}
                            touched={touched.override_bank}
                            errors={errors.override_bank}
                            is_submitted={is_submitted}
                            isSearchable={true}
                            isMulti={true}
                          />
                          <label className="modal-lab">
                            Bank (Optional)
                          </label>
                        </Form.Group>
                        <div className="currentbanklist">
                          {this.state.selectedTypeOfBanks
                            .length ? (
                            this.state.selectedTypeOfBanks.map(
                              (item, index) => (
                                <span
                                  key={
                                    item.value +
                                    "banks" +
                                    index
                                  }
                                  className={
                                    this.state
                                      .activeTypeOfBank
                                      ?.value ===
                                      item.value
                                      ? "active"
                                      : ""
                                  }
                                  onClick={() =>
                                    this.onSelecttypeOfBank(
                                      item,
                                    )
                                  }
                                >
                                  {item.label}
                                </span>
                              ),
                            )
                          ) : (
                            <></>
                          )}
                        </div>
                        <div>
                          {this.state.activeTypeOfBank &&
                            this.state.listOfPdfs?.length ? (
                            <div className="assignbankbody">
                              {this.state.listOfPdfs.map(
                                (item, index) => {
                                  return (
                                    <div
                                      className="currentbankselected"
                                      key={
                                        item +
                                        "pdf" +
                                        index
                                      }
                                    >
                                      <input
                                        type="checkbox"
                                        checked={this.state.selectedPdf.includes(
                                          item,
                                        )}
                                        onChange={(
                                          e,
                                        ) =>
                                          this.onChangePdf(
                                            e,
                                            item,
                                          )
                                        }
                                      />
                                      <label>
                                        {item}
                                      </label>
                                    </div>
                                  );
                                },
                              )}
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      </Form.Row>
                      <div className="selected_addendums">
                        {this.state.selectedPdf.map((item) => {
                          return <span>{item}</span>;
                        })}
                      </div>
                      <Row>
                        <Col md={8}>
                          <Form.Row>
                            <Form.Group
                              as={Col}
                              xs={12}
                              className="px-3 template-select"
                            >
                              <SelectDropDown
                                options={
                                  this.state
                                    .templatesOptions
                                }
                                name="template_id"
                                placeholder="Select Template"
                                value={
                                  this.state.formData
                                    .template_id
                                }
                                handleChange={(
                                  selected,
                                ) => {
                                  if (selected != null) {
                                    values.template_id =
                                      selected.value;
                                    this.handleTemplateOptionChange(
                                      selected,
                                    );
                                    errors.template_id =
                                      "";
                                  }
                                }}
                                touched={
                                  touched.template_id
                                }
                                errors={errors.template_id}
                                is_submitted={is_submitted}
                                clearValue={true}
                                templateReset={() =>
                                  this.templateReset()
                                }
                              />
                              <label className="modal-lab">
                                Template *
                              </label>
                            </Form.Group>
                          </Form.Row>
                        </Col>
                        <Col md={4}>
                          <Button
                            variant={
                              this.state.formData.price !== ""
                                ? "primary"
                                : "light"
                            }
                            size="sm"
                            onClick={() => {
                              this.setState({
                                editPricingModal: true,
                              });
                            }}
                          >
                            {" "}
                            <FaPlus /> Pricing
                          </Button>
                          <Button
                            variant={
                              this.state.formData
                                .equipment !== ""
                                ? "primary"
                                : "light"
                            }
                            size="sm"
                            className="btn-equip-edit"
                            onClick={() => {
                              this.setState({
                                editEquipmentModal: true,
                              });
                            }}
                          >
                            {" "}
                            <FaPlus /> Equipment
                          </Button>
                        </Col>
                      </Row>
                    </>
                  }

                  {user?.is_ems_user && (
                    <Form.Row>
                      <Form.Group
                        as={Col}
                        xs={12}
                        className="px-3 template-select"
                      >
                        <SelectDropDown
                          options={ems_offices}
                          name="ems_office_id"
                          placeholder="Select EMS Office"
                          value={
                            this.state.formData
                              .ems_office_id
                          }
                          handleChange={(selected) => {
                            this.setState({
                              formData: {
                                ...this.state
                                  .formData,
                                ems_office_id:
                                  selected.value,
                              },
                              errorMessage: "",
                            });
                          }}
                          touched={touched.ems_office_id}
                          errors={errors.ems_office_id}
                          is_submitted={is_submitted}
                          clearValue={true}
                          templateReset={() =>
                            this.templateReset()
                          }
                        />
                        <label className="modal-lab">
                          EMS Office
                        </label>
                      </Form.Group>
                    </Form.Row>
                  )}
                </Form>
                {show_spinner ? (
                  <div className="spinner">
                    <Loader />
                  </div>
                ) : (
                  ""
                )}
                <p className="error-message text-center">
                  {errorMessage}
                </p>
                {this.props?.user?.channel == 'sales_channel' ?
                  <div className="modal-footer-area">
                    <Row>
                      <Col xs={6} md={6} className="text-center">
                        <span data-tip data-for="registerTipO">
                          <button
                            onDoubleClick={() =>
                              console.log()
                            }
                            disabled={this.isDisabled(
                              errors,
                            )}
                            form="add-application-form"
                            type="submit"
                            onClick={() =>
                              this.updateSubmitType(
                                "SaveAndRedirect",
                              )
                            }
                            className={`btn btnsendandview w-100 ${this.isDisabled(errors) ? "" : "confirm-button"}`}
                          >
                            {" "}
                            Save{" "}
                          </button>
                        </span>
                        {this.isDisabled(errors) ? (
                          <ReactTooltip
                            data-tip-disable={false}
                            id="registerTipO"
                            place="right"
                            effect="solid"
                            getContent={() => (
                              <div>
                                Have your merchant fill
                                their own information
                                with an
                                <br />
                                attached pricing
                                template! To access,
                                fill all fields <br />{" "}
                                in this box and select a
                                template.
                              </div>
                            )}
                          />
                        ) : null}
                      </Col>

                      <Col xs={6} md={6} className="pl-5 text-center">

                        <a
                          href={void 0}
                          className="btn btn-primary btnsendandview w-40 "
                          onClick={() =>
                            this.props.handleCloseCreatedAppModel()
                          }
                        >
                          {" "}
                          Cancel{" "}
                        </a>
                      </Col>
                    </Row>
                    <Row>&nbsp;</Row>

                  </div>
                  :

                  <div className="modal-footer-area">
                    <Row>
                      <Col xs={3} md={3}></Col>
                      <Col xs={3} md={3} className="p-0">
                        <span data-tip data-for="registerTip">
                          <button
                            disabled={this.isDisabled(
                              errors,
                            )}
                            form="add-application-form"
                            type="submit"
                            onClick={() =>
                              this.updateSubmitType(
                                "Save",
                              )
                            }
                            onMouseEnter={() =>
                              console.log()
                            }
                            className={`btn w-100 btnsendandview ${this.isDisabled(errors) ? "" : "confirm-button"}`}
                          >
                            {" "}
                            Send For Signature{" "}
                          </button>
                        </span>
                        {this.isDisabled(errors) ? (
                          <ReactTooltip
                            data-tip-disable={false}
                            id="registerTip"
                            effect="solid"
                            getContent={() => (
                              <div>
                                Have your merchant fill
                                their own information
                                with an
                                <br />
                                attached pricing
                                template! To access,
                                fill all fields <br />{" "}
                                in this box and select a
                                template.
                              </div>
                            )}
                          />
                        ) : null}
                      </Col>
                      <Col xs={3} md={3} className="pl-5">
                        <span data-tip data-for="registerTipO">
                          <button
                            onDoubleClick={() =>
                              console.log()
                            }
                            disabled={this.isDisabled(
                              errors,
                            )}
                            form="add-application-form"
                            type="submit"
                            onClick={() =>
                              this.updateSubmitType(
                                "SaveAndRedirect",
                              )
                            }
                            className={`btn btnsendandview w-100 ${this.isDisabled(errors) ? "" : "confirm-button"}`}
                          >
                            {" "}
                            View Before Sending{" "}
                          </button>
                        </span>
                        {this.isDisabled(errors) ? (
                          <ReactTooltip
                            data-tip-disable={false}
                            id="registerTipO"
                            place="right"
                            effect="solid"
                            getContent={() => (
                              <div>
                                Have your merchant fill
                                their own information
                                with an
                                <br />
                                attached pricing
                                template! To access,
                                fill all fields <br />{" "}
                                in this box and select a
                                template.
                              </div>
                            )}
                          />
                        ) : null}
                      </Col>
                    </Row>
                    <Row>&nbsp;</Row>
                    <Row>
                      <Col xs={4} md={4}></Col>
                      <Col xs={4} md={4}>
                        <a
                          href={void 0}
                          className="pointer"
                          onClick={() =>
                            this.props.handleCloseCreatedAppModel()
                          }
                        >
                          {" "}
                          Cancel{" "}
                        </a>
                      </Col>
                      <Col xs={4} md={4}></Col>
                    </Row>
                  </div>
                }
              </>
            )}
          </Formik>

          {this.state.editPricingModal && (
            <EditPricingCreateApp
              show={true}
              handleClose={() =>
                this.setState({ editPricingModal: false })
              }
              pricingData={
                this.state.formData.price == ""
                  ? ""
                  : JSON.parse(this.state.formData.price)
              }
              setData={(pricing) =>
                this.setUpdatePricingData(pricing)
              }
            />
          )}

        {this.state.editEquipmentModal && (
          <EditEquipmentCreateApp
            show={true}
            handleCloseModel={() =>
              this.setState({ editEquipmentModal: false })
            }
            selectedTemplate={
              this.state.formData.equipment == ""
                ? ""
                : JSON.parse(this.state.formData.equipment)
            }
            setData={(equipment) =>
              this.setUpdateEquipmentData(equipment)
            }
          />
        )}
      </div>
    );
  }
}

export default ApplicationFormTab;
